import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import { register, load, getInstances } from '@shopify/theme-sections';
import * as a11y from '@shopify/theme-a11y';
import Swiper, { Navigation, Pagination, Thumbs, EffectFade } from 'swiper';
import * as ProductUtil from '../utilities/product-utils';
import * as LibraryLoader from '../utilities/library-loader-webpack';
import * as Helpers from '../utilities/helpers';
import * as DesignModeUtil from '../utilities/design-mode-util';
Swiper.use([Navigation, Pagination, Thumbs, EffectFade]);
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'featured-product';

Avatar.theme.sections.FeaturedProduct = function FeaturedProduct() {
  var selectors = {
    productMedia: '.product-media',
    productMediaItem: '[data-media-id]',
    productMediaById: function productMediaById(id) {
      return "[data-product-media=\"".concat(id, "\"]");
    },
    productMediaNav: '.product-media-nav',
    productMediaNavItem: '.product-media-nav-item',
    productMediaNavById: function productMediaNavById(id) {
      return "[data-product-media-nav=\"".concat(id, "\"]");
    },
    productForm: '.product-form',
    storeAvailabilityContainer: '[data-store-availability-container]',
    productTabs: '[data-tabs]',
    productVariant: '.product-variant',
    productSku: '[data-sku]',
    productQuantityStep: '.product-quantity-step',
    productQuantityInput: '.product-quantity-input',
    productPrices: '.product-prices',
    productPrice: '.product-price',
    productComparePrice: '.product-compare-price',
    productUnitPrice: '[data-unit-price]',
    productUnitPriceBase: '[data-unit-price-base-unit]',
    productButton: '.product-button',
    productButtonText: '.product-button__text',
    productOption: '.product-option',
    productOptionLabel: '.form-check-label',
    productOptionByIdex: function productOptionByIdex(index) {
      return "[data-product-option-".concat(index, "]");
    },
    checkedInput: 'input:checked',
    productHandle: '[data-product-handle]',
    jsPlayer: '.js-player',
    ytPlayer: '.yt-player',
    vmPlayer: '.vm-player',
    modelViewer: '.model-viewer',
    swatchInputById: function swatchInputById(id) {
      return "[id='".concat(id, "']");
    },
    swatchByOptionIndex: function swatchByOptionIndex(index) {
      return ".form-check-swatch[data-option-index=\"".concat(index, "\"]");
    },
    swatchInputByOptionIndex: function swatchInputByOptionIndex(index) {
      return "\n      .form-check-swatch[data-option-index=\"".concat(index, "\"]\n      .form-check-input\n    ");
    },
    stickyCart: '.sticky-cart',
    stickyAddCart: '[data-sticky-add-to-cart]',
    stickySelectOptions: '[data-select-options]',
    sliderNextWithParentId: function sliderNextWithParentId(id) {
      return "#shopify-section-".concat(id, " .swiper-button-next");
    },
    sliderPrevWithParentId: function sliderPrevWithParentId(id) {
      return "#shopify-section-".concat(id, " .swiper-button-prev");
    },
    sliderNavThumbActive: function sliderNavThumbActive(name) {
      return ".".concat(name);
    },
    productJsonBySectionId: function productJsonBySectionId(id) {
      return "ProductJson-".concat(id);
    }
  };
  var classes = {
    soldout: 'soldout',
    hideOption: 'hide-option',
    showOption: 'show-option',
    active: 'active',
    hidden: 'tw-hidden',
    invisible: 'tw-invisible',
    defaultCursor: 'tw-cursor-default',
    sliderDisabledClass: 'swiper-button-disabled invisible',
    sliderNavThumbActive: 'swiper-slide-thumb-active',
    iframeWrapper: 'tw-video-wrapper'
  };
  var ENTER_KEY_CODE = 13;
  var SPACE_KEY_CODE = 32;
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      var container = this.container;
      this.sectionId = container.getAttribute('data-section-id');
      this.productContainer = container;
      this.productMedia = container.querySelector(selectors.productMedia);
      this.productMediaItems = container.querySelectorAll(selectors.productMediaItem);
      this.productMediaNav = container.querySelector(selectors.productMediaNav);
      this.productMediaNavButtons = container.querySelectorAll(selectors.productMediaNavItem);
      this.productForm = container.querySelector(selectors.productForm);
      this.storeAvailabilityContainer = container.querySelector(selectors.storeAvailabilityContainer);
      this.productTabs = container.querySelector(selectors.productTabs);
      this.productVariant = container.querySelector(selectors.productVariant);
      this.productSku = container.querySelector(selectors.productSku);
      this.productQuantityStep = container.querySelectorAll(selectors.productQuantityStep);
      this.productQuantityInput = container.querySelector(selectors.productQuantityInput);
      this.productPrices = container.querySelector(selectors.productPrices);
      this.productPrice = container.querySelector(selectors.productPrice);
      this.productComparePrice = container.querySelector(selectors.productComparePrice);
      this.productUnitPrice = container.querySelector(selectors.productUnitPrice);
      this.productUnitPriceBase = container.querySelector(selectors.productUnitPriceBase);
      this.productButton = container.querySelector(selectors.productButton);
      this.productButtonText = container.querySelector(selectors.productButtonText);
      this.productOption = container.querySelectorAll(selectors.productOption);
      this.productHandle = container.querySelector(selectors.productHandle);
      this.ytPlayers = container.querySelectorAll(selectors.ytPlayer);
      this.vmPlayers = document.querySelectorAll(selectors.vmPlayer);
      this.jsPlayers = container.querySelectorAll(selectors.jsPlayer);
      Avatar.theme.videos = Avatar.theme.videos || {};
      Avatar.theme.videoPlayers = Avatar.theme.videoPlayers || [];
      this.modelViewers = container.querySelectorAll(selectors.modelViewer);
      this.productMediaSwiper = [];
      this.productMediaNavSwiper = [];
      Avatar.theme.jsPlayersCollection = Avatar.theme.jsPlayersCollection || [];
      this.modelViewersCollection = [];
      this.eventHandlers = {};
      this.settings = {};
      this.optionsMap = {};

      if (this.productContainer) {
        this.getSettings();
        this.initProductMedia();
        this.initProductForm();
        this.initRteIframes();
      }

      if (this.productForm) {
        this.eventHandlers.handleOnKeyDown = this.handleOnKeyDown.bind(this);
        this.productForm.addEventListener('keydown', this.eventHandlers.handleOnKeyDown);
      }

      if (this.productTabs) {
        this.productTabs = new Avatar.theme.Tabs(this.productTabs);
      }

      if (this.productQuantityInput) {
        this.eventHandlers.handleQuantityClick = this.handleQuantityClick.bind(this);
        this.productQuantityStep.forEach(function (step) {
          step.addEventListener('click', _this.eventHandlers.handleQuantityClick.bind(_this));
        });
        this.eventHandlers.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.productQuantityInput.addEventListener('change', this.eventHandlers.handleQuantityChange.bind(this));
      }
    },
    getSettings: function getSettings() {
      this.settings = JSON.parse(this.productContainer.getAttribute('data-product-settings'));
      return this.settings;
    },
    initProductMedia: function initProductMedia() {
      var _this2 = this;

      if (!this.productMedia) {
        return;
      }

      if (this.productMediaItems.length === 1) {
        this.productMediaItems[0].classList.remove(classes.invisible);
      }

      if (this.jsPlayers.length > 0) {
        Shopify.loadFeatures([{
          name: 'video-ui',
          version: '1.0',
          onLoad: this.setupPlyrVideos.bind(this)
        }]);
        LibraryLoader.load('plyrShopifyStyles');
      }

      if (this.ytPlayers.length > 0) {
        if (!window.youtubeLoaded) {
          var tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        window.YTQueue.queueItem(function () {
          _this2.container.querySelectorAll(selectors.ytPlayer).forEach(function (player) {
            Avatar.theme.videoPlayers.push(new YT.Player(player));
          });
        });
      }

      if (this.vmPlayers.length > 0) {
        if (!window.vimeoLoaded) {
          var _tag = document.createElement('script');

          _tag.src = 'https://player.vimeo.com/api/player.js';
          var _firstScriptTag = document.getElementsByTagName('script')[0];

          _firstScriptTag.parentNode.insertBefore(_tag, _firstScriptTag);
        }

        Helpers.checkVimeoReady().then(function () {
          _this2.container.querySelectorAll(selectors.vmPlayer).forEach(function (player) {
            Avatar.theme.videoPlayers.push(new Vimeo.Player(player));
          });
        }).catch(function (err) {
          return console.log(err);
        });
      }

      if (this.modelViewers.length > 0) {
        Avatar.theme.ProductModel.init(this.sectionId);
      }

      if (this.productMediaNav) {
        var self = this;
        this.productMediaNavSwiper = new Swiper(selectors.productMediaNavById(this.id), {
          observer: true,
          observeParents: true,
          slidesPerView: 6,
          spaceBetween: 1,
          touchRatio: 1,
          breakpoints: {
            768: {
              slidesPerGroup: 2,
              touchRatio: 0,
              navigation: {
                nextEl: selectors.sliderNextWithParentId(this.id),
                prevEl: selectors.sliderPrevWithParentId(this.id),
                disabledClass: classes.sliderDisabledClass
              }
            }
          }
        });
        this.productMediaSwiper = new Swiper(selectors.productMediaById(this.id), {
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: selectors.sliderNextWithParentId(this.id),
            prevEl: selectors.sliderPrevWithParentId(this.id),
            disabledClass: classes.sliderDisabledClass
          },
          preloadImages: false,
          autoHeight: true,
          simulateTouch: false,
          preventClicks: false,
          preventClicksPropagation: false,
          followFinger: false,
          thumbs: {
            swiper: this.productMediaNavSwiper,
            autoScrollOffset: 2,
            slideThumbActiveClass: classes.sliderNavThumbActive
          },
          on: {
            afterInit: function afterInit() {
              setTimeout(function () {
                if (self.productMediaItems[0].hasAttribute('data-product-media-type-model')) {
                  self.productMediaSwiper.allowTouchMove = false;
                }
              }, 0);
            },
            slideChange: function slideChange() {
              if (self.productMediaSwiper.slides.length > 0) {
                var eventOptions = {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                    swiper: self.productMediaSwiper
                  }
                };
                var _self$productMediaSwi = self.productMediaSwiper,
                    _slides = _self$productMediaSwi.slides,
                    previousIndex = _self$productMediaSwi.previousIndex,
                    _realIndex = _self$productMediaSwi.realIndex;
                var previousSlide = _slides[previousIndex];
                var currentSlide = _slides[_realIndex];
                previousSlide.dispatchEvent(new CustomEvent('mediaHidden', eventOptions));
                currentSlide.dispatchEvent(new CustomEvent('mediaVisible', eventOptions));
                currentSlide.classList.remove(classes.invisible);
              }

              var _self$productMediaSwi2 = self.productMediaSwiper,
                  slides = _self$productMediaSwi2.slides,
                  realIndex = _self$productMediaSwi2.realIndex;

              if (Avatar.theme.videoPlayers.length > 0) {
                Avatar.theme.videoPlayers.forEach(function (player) {
                  if (typeof player.pauseVideo === 'function') {
                    player.pauseVideo();
                  } else if (typeof player.pause === 'function') {
                    player.pause();
                  }
                });
                Avatar.theme.videoPlayers.forEach(function (player) {
                  if (_typeof(player.h) === 'object' && player.h === slides[realIndex].firstElementChild) {
                    player.playVideo();
                  } else if (_typeof(player.element) === 'object' && player.element === slides[realIndex].firstElementChild) {
                    player.play();
                  }
                });
              }

              if (Avatar.theme.jsPlayersCollection.length > 0) {
                Avatar.theme.jsPlayersCollection.forEach(function (player) {
                  return player.pause();
                });
                Avatar.theme.jsPlayersCollection.forEach(function (player) {
                  if (player.elements.container === slides[realIndex].firstElementChild) {
                    player.play();
                  }
                });
              }

              self.setCurrentSlideAttributes();
            }
          }
        });
        this.productMediaNav.addEventListener('keydown', this.handleThumbnailKeyDown.bind(this));
        this.productMediaNavButtons.forEach(function (button) {
          button.addEventListener('click', _this2.handleThumbnailClick.bind(_this2));
        });
      }
    },
    handleThumbnailKeyDown: function handleThumbnailKeyDown(evt) {
      if (![SPACE_KEY_CODE, ENTER_KEY_CODE].includes(evt.keyCode)) {
        return;
      }

      var index = Array.from(this.productMediaNav.querySelectorAll(selectors.productMediaNavItem)).indexOf(evt.target);
      this.productMediaSwiper.slideTo(index);
    },
    setCurrentSlideAttributes: function setCurrentSlideAttributes() {
      var _this3 = this;

      var thumbs = this.productMediaNav.querySelectorAll(selectors.productMediaNavItem);
      thumbs.forEach(function (thumb) {
        return thumb.removeAttribute('aria-current');
      });
      setTimeout(function () {
        var activeThumb = _this3.productMediaNav.querySelector(selectors.sliderNavThumbActive(classes.sliderNavThumbActive));

        if (activeThumb) {
          activeThumb.setAttribute('aria-current', true);
        }
      }, 300);
    },
    handleThumbnailClick: function handleThumbnailClick(evt) {
      var currentTarget = evt.currentTarget;
      var slideIndex = currentTarget.dataset.slideIndex;
      var targetSlide = this.productMediaSwiper.slides[slideIndex];
      this.productMediaSwiper.slideTo(slideIndex);
      targetSlide.classList.remove(classes.invisible);
      Helpers.forceFocus(targetSlide, {
        preventScroll: true
      });
    },
    setupPlyrVideos: function setupPlyrVideos() {
      this.jsPlayers.forEach(function (player) {
        Avatar.theme.jsPlayersCollection.push(new Shopify.Plyr(player));
      });
    },
    setupModelViewerUi: function setupModelViewerUi() {
      if (Shopify.ModelViewerUI) {
        this.modelViewersCollection = Shopify.ModelViewerUI.setup(selectors.modelViewer);
      }
    },
    initProductForm: function initProductForm() {
      if (!this.productForm) {
        return;
      }

      var jsonTag = document.getElementById(selectors.productJsonBySectionId(this.sectionId));

      if (!jsonTag || !jsonTag.innerHTML.length) {
        return;
      }

      var productJson = JSON.parse(jsonTag.innerHTML);

      if (!productJson.available && !this.settings.showUnavailable) {
        this.productOption.forEach(function (options) {
          return options.classList.add(classes.hidden);
        });
      }

      var self = this;

      if (productJson && productJson.options.length >= 1) {
        if (this.settings.variantSelectors === 'swatches') {
          this.initLinkedOptions(productJson);
        }
      }

      productJson.options = productJson.options.map(function (option) {
        return {
          name: option
        };
      });
      this.productFormInstance = new Avatar.theme.ProductForm(this.productForm, productJson, {
        onOptionChange: function onOptionChange(e) {
          var _e$dataset = e.dataset,
              variant = _e$dataset.variant,
              options = _e$dataset.options;
          ProductUtil.renderMedia(self.productMediaSwiper, variant, self.productMediaItems);
          ProductUtil.renderPrice(self.productPrices, self.productPrice, variant);
          ProductUtil.renderComparePrice(self.productComparePrice, variant);
          ProductUtil.renderUnitPrice(self.productUnitPrice, self.productUnitPriceBase, variant);
          ProductUtil.renderSku(self.productSku, variant);
          ProductUtil.renderButton(self.productButtonText, variant);
          ProductUtil.updateVariant(self.productVariant, variant);
          ProductUtil.updateStoreAvailabilityContent(self.storeAvailability, variant);

          if (self.settings.variantSelectors === 'swatches') {
            self.updateSwatches(productJson);
          }
        }
      });
      ProductUtil.renderMedia(self.productMediaSwiper, this.productFormInstance.variant(), this.productMediaItems);
      ProductUtil.renderButton(self.productButtonText, this.productFormInstance.variant());
      var currentOptions = this.productFormInstance.options();
      var currentVariant = this.productFormInstance.variant();

      if (this.storeAvailabilityContainer) {
        this.storeAvailability = new Avatar.theme.StoreAvailability(this.storeAvailabilityContainer);
      }

      if (this.storeAvailability && currentVariant.available) {
        this.storeAvailability.updateContent(currentVariant.id);
      }

      if (this.settings.ajaxSubmit) {
        DesignModeUtil.initAjaxAddToCart(this.container);
      }
    },
    initRteIframes: function initRteIframes() {
      var iframes = Avatar.theme.rte.iframeSelectors;
      Avatar.theme.rte.wrapIframe({
        iframes: document.querySelectorAll(iframes),
        iframeWrapperClass: classes.iframeWrapper
      });
    },
    handleQuantityClick: function handleQuantityClick(evt) {
      var currentTarget = evt.currentTarget;

      if (currentTarget.hasAttribute('data-step-up')) {
        this.productQuantityInput.stepUp();
      } else if (currentTarget.hasAttribute('data-step-down')) {
        this.productQuantityInput.stepDown();
      }

      if (parseInt(this.productQuantityInput.value, 10) <= 1) {
        this.productQuantityInput.previousElementSibling.setAttribute('disabled', true);
      } else {
        this.productQuantityInput.previousElementSibling.removeAttribute('disabled');
      }
    },
    handleQuantityChange: function handleQuantityChange(evt) {
      var currentTarget = evt.currentTarget;

      if (currentTarget.value === '1') {
        currentTarget.previousElementSibling.setAttribute('disabled', true);
      } else {
        currentTarget.previousElementSibling.removeAttribute('disabled');
      }
    },
    getProductJson: function getProductJson() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var productHandle, product;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                productHandle = _this4.productContainer.dataset.productHandle; // eslint-disable-next-line max-len

                _context.next = 3;
                return fetch("/products/".concat(productHandle, ".js")).then(function (response) {
                  return response.json();
                });

              case 3:
                product = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    updateOptionsInSelector: function updateOptionsInSelector(selectorIndex, product) {
      var _this5 = this;

      var key;

      var getKey = function getKey(optionLevel) {
        var option;
        var checkedValue;

        if (optionLevel === 1) {
          // eslint-disable-next-line prefer-destructuring
          option = _this5.productContainer.querySelectorAll(selectors.productOption)[0];
          checkedValue = option.querySelector(selectors.checkedInput).value;
        } else {
          option = _this5.productContainer.querySelectorAll(selectors.productOption)[0].querySelector(selectors.checkedInput).value;
          option += ' / ';
          option += _this5.productContainer.querySelectorAll(selectors.productOption)[1].querySelector(selectors.checkedInput).value;
          checkedValue = option;
        }

        return checkedValue;
      };

      switch (selectorIndex) {
        case 0:
          key = 'root';
          break;

        case 1:
          key = getKey(selectorIndex);
          break;

        case 2:
          key = getKey(selectorIndex);
          break;

        default:
          console.log('error');
      }

      var initialValue = key;
      var availableOptions = this.optionsMap[initialValue];
      var swatchInputOptionRow = this.productContainer.querySelectorAll(selectors.swatchInputByOptionIndex(selectorIndex));
      var colorIndex = product.options.findIndex(function (option) {
        var value = option;

        if (_typeof(option) === 'object') {
          value = option.name;
        }

        return value.toLowerCase() === 'color';
      });

      if (colorIndex !== -1) {
        var optionContainer = this.productContainer.querySelector(selectors.productOptionByIdex(colorIndex));
        var colorValue = optionContainer.querySelector(selectors.checkedInput).value;
        var span = optionContainer.querySelector('label span');

        if (span) {
          span.innerHTML = colorValue;
        }
      }

      if (this.settings.hideSingleOption && !this.settings.showUnavailable) {
        var optionRow = swatchInputOptionRow[0].closest(selectors.productOption);

        if (availableOptions.length <= 1) {
          optionRow.classList.add(classes.hidden);
        } else {
          optionRow.classList.remove(classes.hidden);
        }
      }

      swatchInputOptionRow.forEach(function (swatchInput) {
        var swatchValue = swatchInput.value;
        var swatchContainer = swatchInput.parentElement;

        if (availableOptions && availableOptions.includes(swatchValue)) {
          swatchContainer.classList.remove(classes.hidden, classes.soldout);
          swatchContainer.querySelector('input').removeAttribute('disabled');
          swatchContainer.querySelector('label').classList.remove(classes.defaultCursor);
          swatchContainer.classList.add(classes.showOption);
          swatchContainer.classList.remove(classes.hideOption);
        } else {
          if (!_this5.settings.showUnavailable) {
            swatchContainer.classList.add(classes.hidden);
          }

          if (_this5.settings.disableUnavailable) {
            swatchContainer.querySelector('label').classList.add(classes.defaultCursor);
            swatchContainer.querySelector('input').setAttribute('disabled', true);
          }

          swatchContainer.classList.remove(classes.showOption);
          swatchContainer.classList.add(classes.hideOption);
          swatchContainer.classList.add(classes.soldout);
        }
      });

      if (this.settings.disableUnavailable) {
        var currentCheckedOption;
        var currentOptions = this.productContainer.querySelectorAll(selectors.swatchByOptionIndex(selectorIndex));
        currentOptions.forEach(function (option) {
          var optionInput = option.querySelector('input');

          if (optionInput.checked) {
            currentCheckedOption = option.querySelector(selectors.checkedInput).parentElement;
          }
        });

        if (currentCheckedOption) {
          if (currentCheckedOption.classList.contains(classes.hideOption)) {
            var firstAvailableOption = currentOptions[0].parentElement.querySelector(".form-check-swatch.".concat(classes.showOption));
            firstAvailableOption && firstAvailableOption.querySelector('input').click();
          }
        }
      }
    },
    initLinkedOptions: function initLinkedOptions(product) {
      // Building our mapping object.
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i]; // Add code back to variant.available if needed

        if (variant.available) {
          // Gathering values for the 1st drop-down.
          this.optionsMap.root = this.optionsMap.root || [];
          this.optionsMap.root.push(variant.option1);
          this.optionsMap.root = Helpers.uniq(this.optionsMap.root); // Gathering values for the 2nd drop-down.

          if (product.options.length > 1) {
            var key = variant.option1;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option2);
            this.optionsMap[key] = Helpers.uniq(this.optionsMap[key]);
          } // Gathering values for the 3rd drop-down.


          if (product.options.length === 3) {
            var _key = "".concat(variant.option1, " / ").concat(variant.option2);

            this.optionsMap[_key] = this.optionsMap[_key] || [];

            this.optionsMap[_key].push(variant.option3);

            this.optionsMap[_key] = Helpers.uniq(this.optionsMap[_key]);
          }
        }
      }

      this.updateSwatches(product);
    },
    updateSwatches: function updateSwatches(product) {
      this.updateOptionsInSelector(0, product);
      if (product.options.length > 1) this.updateOptionsInSelector(1, product);
      if (product.options.length === 3) this.updateOptionsInSelector(2, product);
    },
    handleOnKeyDown: function handleOnKeyDown(evt) {
      var _this6 = this;

      if ([SPACE_KEY_CODE, ENTER_KEY_CODE].includes(evt.keyCode)) {
        var labels = this.productContainer.querySelectorAll(selectors.productOptionLabel);
        labels.forEach(function (label) {
          if (label === document.activeElement) {
            evt.preventDefault();
            var inputSelector = selectors.swatchInputById(label.getAttribute('for'));
            _this6.productContainer.querySelector(inputSelector).checked = true;
            var changeEvent = new Event('change');

            _this6.productContainer.querySelector(inputSelector).dispatchEvent(changeEvent);
          }
        });
      }
    },
    onUnload: function onUnload() {
      var _this7 = this;

      if (this.productForm) {
        this.productForm.removeEventListener('keydown', this.eventHandlers.handleOnKeyDown);
      }

      this.productQuantityStep.forEach(function (step) {
        step.removeEventListener('click', _this7.eventHandlers.handleQuantityClick.bind(_this7));
      });

      if (this.productQuantityInput) {
        this.productQuantityInput.removeEventListener('change', this.eventHandlers.handleQuantityChange.bind(this));
      }

      if (this.productFormInstance) {
        this.productFormInstance.destroy();
      }

      if (this.productMediaNav) {
        this.productMediaNav.removeEventListener('keydown', this.handleThumbnailKeyDown.bind(this));
        this.productMediaNavButtons.forEach(function (button) {
          button.removeEventListener('click', _this7.handleThumbnailClick.bind(_this7));
        });
      }

      if (this.productMediaNavSwiper.initialized) {
        this.productMediaNavSwiper.destroy();
      }

      if (this.productMediaSwiper.initialized) {
        this.productMediaSwiper.destroy();
      }

      this.productTabs.destroy();

      if (this.settings.ajaxSubmit) {
        DesignModeUtil.initAjaxAddToCartDestroy();
      }

      Avatar.theme.ProductModel.removeSectionModels(this.sectionId);
    }
  });
  load(sectionName);
  var instances = getInstances(sectionName);
  return instances;
}();